// extracted by mini-css-extract-plugin
export var chevron = "_p1-1";
export var clickable = "_p1-0";
export var ruleRow = "_p1-2";